import React from 'react';
import {Switch, Route} from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from './components/Navbar';
import ProductList from './components/ProductList';
import Details from './components/Details';
import Default from './components/Default';
import Cart from './components/Cart';
import Modal from './components/Modal';
import Home from './components/Home';
import Foot from './components/Foot';
import Contact from './components/Contact';
function App() {
  
  return (
      <React.Fragment>
       <Navbar/>
       <Switch>
       <Route exact path = "/" component={Home}/>
          <Route path ="/details" component={Details}/>
          <Route path ="/cart" component={Cart} />
          <Route path ="/products" component={ProductList} />
          <Route path ="/contact" component={Contact}/>
          <Route component={Default} />
       </Switch>
       <Modal/>
       <Foot/>
      </React.Fragment>

  );
}

export default App;
